<div class="dialog-content-wrapper">
    <mat-toolbar class="mat-primary m-0">
        <mat-toolbar-row
            fxFlex
            fxLayout="row"
            fxLayoutAlign="space-between center"
        >
            <span class="title dialog-title text-truncate">Usuario</span>
            <button
                mat-icon-button
                (click)="dialogRef.close()"
                aria-label="Close dialog"
            >
                <mat-icon>close</mat-icon>
            </button>
        </mat-toolbar-row>
    </mat-toolbar>

    <mat-dialog-content class="p-16 pb-0 m-0">
        <form class="form" [formGroup]="formCliente" autocomplete="off">
            <mat-form-field *ngIf="!data.editar" class="full-width">
                <mat-label>Rut </mat-label>
                <input
                    matInput
                    type="text"
                    formControlName="rut"
                    required
                    (blur)="buscarEncargado()"
                />
                <mat-hint>Rut con formato 12345678-9</mat-hint>
                <mat-error *ngIf="rut.hasError('required')">
                    Debe ingresar el rut del cliente
                </mat-error>
                <mat-error *ngIf="rut.hasError('digitoVerificador')">
                    Debe ingresar un rut válido
                </mat-error>
            </mat-form-field>

            <mat-form-field class="full-width">
                <mat-label>Nombres </mat-label>
                <input
                    matInput
                    type="text"
                    formControlName="nombres"
                    required
                />

                <mat-error *ngIf="nombres.hasError('required')">
                    Debe ingresar el nombre del usuario
                </mat-error>
                <mat-error *ngIf="nombres.hasError('minlength')">
                    El nombre debe tener al menos 3 caracteres
                </mat-error>
                <mat-error *ngIf="nombres.hasError('maxlength')">
                    El nombre no puede ser mayor a 100 caracteres
                </mat-error>
            </mat-form-field>

            <mat-form-field class="full-width">
                <mat-label>Apellidos </mat-label>
                <input
                    matInput
                    type="text"
                    formControlName="apellidos"
                    required
                />
                <mat-error *ngIf="apellidos.hasError('required')">
                    Debe ingresar el apellido del usuario
                </mat-error>
                <mat-error *ngIf="apellidos.hasError('minlength')">
                    El apellido debe tener al menos 3 caracteres
                </mat-error>
                <mat-error *ngIf="apellidos.hasError('maxlength')">
                    El apellido no puede ser mayor a 100 caracteres
                </mat-error>
            </mat-form-field>

            <mat-form-field class="full-width">
                <mat-label>Correo Electrónico </mat-label>
                <input matInput type="text" formControlName="correo" required />
                <mat-error *ngIf="correo.errors">
                    Debe ingresar un correo con el formato correcto
                    xxxxx@yyyy.zz
                </mat-error>
            </mat-form-field>

            <div *ngIf="data.esEncargado">
                <h3><strong>Permisos:</strong></h3>

                <mat-checkbox formControlName="puedeCotizar">
                    Cotizar
                    <small
                        >(Permiso para realizar solicitudes de cotizaciones de
                        servicios)</small
                    >
                </mat-checkbox>
                <br />

                <mat-checkbox formControlName="puedeComprar">
                    Comprar
                    <small
                        >(Permiso para solicitar (comprar) servicios de una
                        cotización)</small
                    >
                </mat-checkbox>
                <br />

                <mat-checkbox formControlName="puedeRecibir">
                    Recibir
                    <small
                        >(Permiso para recibir una OT (trabajo) que se encuentra
                        terminada)</small
                    >
                </mat-checkbox>
            </div>

            <!-- input
                    matInput
                    type="checkbox"
                    formControlName="puedeComprar"
                    required
                />

                <input
                    matInput
                    type="checkbox"
                    formControlName="puedeRecibir"
                    required
                / -->

            <!-- mat-error *ngIf="apellidos.hasError('required')">
                    Debe ingresar el apellido del usuario
                </mat-error -->
        </form>
    </mat-dialog-content>

    <mat-dialog-actions
        class="m-0 p-16"
        fxLayout="row"
        fxLayoutAlign="end center"
    >
        <button mat-button mat-dialog-close>Cancelar</button>
        <button
            mat-raised-button
            color="accent"
            [mat-dialog-close]="formCliente.value"
            [disabled]="!formCliente.valid"
        >
            Guardar
        </button>
    </mat-dialog-actions>
</div>
